export function buildVersionedTitle(title: string, version: string = ''): string {
  const trimmedVersion = version.trim();

  if (!trimmedVersion) {
    return title;
  }

  return `${title} ${trimmedVersion}`;
}
